import { render } from "./Search.vue?vue&type=template&id=6273fad0&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6273fad0"

export default script